export type LoyaltyMedal = {
  src: string;
  label: string;
};

const MEDALS: { [key: string]: string } = {
  bronze: '/medals/bronze-medal.png',
  silver: '/medals/silver-medal.png',
  gold: '/medals/gold-medal.png',
};

/** Map category name (any case / locale) or known key to medal asset. */
export function resolveLoyaltyMedal(
  categoryName: string | null | undefined
): LoyaltyMedal | null {
  if (!categoryName) {
    return null;
  }
  const raw = String(categoryName).trim();
  if (!raw) {
    return null;
  }
  const key = raw.toLowerCase();
  if (key.indexOf('bronze') !== -1 || key.indexOf('бронз') !== -1) {
    return { src: MEDALS.bronze, label: raw };
  }
  if (key.indexOf('silver') !== -1 || key.indexOf('серебр') !== -1) {
    return { src: MEDALS.silver, label: raw };
  }
  if (key.indexOf('gold') !== -1 || key.indexOf('золот') !== -1) {
    return { src: MEDALS.gold, label: raw };
  }
  return null;
}

export function loyaltyCategoryLabel(row: any): string {
  if (!row) {
    return '';
  }
  const nested = row.loyaltyCategory;
  const nestedName =
    nested && typeof nested === 'object'
      ? nested.name || nested.loyaltyCategory || ''
      : typeof nested === 'string'
      ? nested
      : '';
  const nestedId =
    nested && typeof nested === 'object' && nested.id !== undefined && nested.id !== null
      ? String(nested.id)
      : '';

  return (
    nestedName ||
    row.loyaltyCategoryName ||
    row.categoryName ||
    (row.loyaltyCategoryId !== undefined && row.loyaltyCategoryId !== null
      ? String(row.loyaltyCategoryId)
      : '') ||
    nestedId ||
    ''
  );
}
